export enum Sizes {
  sm = '33%',
  md = '50%',
  lg = '100%',
}
